import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54')
];

export const server_loads = [0,2,3,4,5,6,7];

export const dictionary = {
		"/": [~8],
		"/admin/payouts": [~10],
		"/admin/videos": [~11],
		"/admin/videos/new": [~13],
		"/admin/videos/[asset_id]": [~12],
		"/ai-or-not": [~14],
		"/auth/invite": [15],
		"/auth/oauth-error": [~16],
		"/bundles": [~17],
		"/bundles/statistics": [~21],
		"/bundles/[age_group=age_group]": [~18],
		"/bundles/[bundle]": [~19,[2]],
		"/bundles/[bundle]/[purchase_intent=purchase_intent]": [~20,[2]],
		"/classrooms/[classroom_id]/learn": [~22],
		"/courses": [~23],
		"/courses/[age_group=age_group]": [~24],
		"/courses/[course]": [~25,[3]],
		"/courses/[course]/lessons": [27,[3]],
		"/courses/[course]/review": [28,[3]],
		"/courses/[course]/[purchase_intent=purchase_intent]": [~26,[3]],
		"/escape": [~29],
		"/for-schools": [~30],
		"/for-schools/refer": [~31],
		"/for-schools/teachers": [~32],
		"/join": [33],
		"/milos-mind-redirect": [~34],
		"/my-classrooms": [35,[4]],
		"/my-classrooms/[classroom_id]": [36,[4]],
		"/my-classrooms/[classroom_id]/presentation": [37,[4]],
		"/my-school": [38,[5]],
		"/pay": [39],
		"/privacy": [~40],
		"/purchase-success": [~41],
		"/puzzles": [~42,[6]],
		"/puzzles/[puzzle]": [~43,[6]],
		"/resources": [~44],
		"/resources/[path]": [~45],
		"/scratchpad/buttons": [46],
		"/simulator": [~47],
		"/social-media-simulator": [~48],
		"/terms": [~49],
		"/worksheets": [~50],
		"/worksheets/[age_group=age_group]": [~51],
		"/worksheets/[worksheet]": [~52,[7]],
		"/worksheets/[worksheet]/review": [54,[7]],
		"/worksheets/[worksheet]/[purchase_intent=purchase_intent]": [~53,[7]],
		"/[content_page]": [~9]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';